import { useFirebaseNotification } from '@/lib/firebase/use-firebase-notification';
import {
  useActiveWorkspacesQuery,
  useGetWalletDetailsV2Query,
  useWorkspaceRateLimitsQuery,
  useauthMeQuery,
  useworkspaceAuthMeV2Query,
  useListPaymentOrdersQuery,
} from '@/types/generated/graphql';
import { CONFIRM_PAYMENT_BADGE_VARIABLES } from '@components/confirm-payment/confirm-payment.constants';
import useAssignChannels from '@modules/channels/hooks/use-submenu-assign-channels';
import { useDialerStore } from '@modules/phone/store/dialer.store';
import { PropsWithChildren, useEffect } from 'react';
import { useLocation, useMatch } from 'react-router-dom';
import { useCallEvents } from './use-call-events';
import { useDeviceEvents } from './use-device-events';
import { useDraftMessageMutation } from './use-draft-message';
import { useDeviceStore } from '@modules/phone/store/device.store';
import { useNetworkDetector } from './use-network-detector';
import { config } from '@/lib/env-helpers';
import { useCaptureSentryUser } from './use-capture-sentry-user';

export function AppBootstrap({ children }: PropsWithChildren) {
  const matchConversation = useMatch({
    path: '/conversations/:channelId',
    end: false,
  });
  const location = useLocation();

  const setDialerChannelId = useDialerStore((s) => s.setDialerChannelId);
  const call = useDeviceStore((s) => s.call);

  const { data: channelsData } = useAssignChannels();
  useauthMeQuery({
    onCompleted: ({ authMe }) => {
      if (authMe?.data?.user?.uiVersion === 'v1') {
        window.location.replace(config.VAROSA_OLD_DESIGN + '/design-switch');
      }
    },
  });
  useworkspaceAuthMeV2Query();
  useCaptureSentryUser();
  useGetWalletDetailsV2Query();
  useActiveWorkspacesQuery();
  useWorkspaceRateLimitsQuery();
  useListPaymentOrdersQuery({ variables: CONFIRM_PAYMENT_BADGE_VARIABLES });

  // draft event
  useDraftMessageMutation();

  // firebase notification
  useFirebaseNotification();

  // twilio events
  useDeviceEvents();
  useCallEvents();

  useNetworkDetector();

  // !TODO Refactor
  const channelId = matchConversation?.params?.channelId;
  // when route changes in message conversation and there is channelId in the route update channelId
  useEffect(
    function updateActiveChannelId() {
      // do not change the active channel when there is ongoing call
      if (call) return;

      const isMessageConversation = location.pathname.includes('/conversation');

      if (channelId && isMessageConversation) {
        setDialerChannelId(+channelId);
      } else if (channelsData?.data?.length) {
        // use first channel as default when there is no default channel
        const defaultChannelId =
          channelsData.data.find((c) => c?.isDefault)?.channel?.id ?? channelsData.data[0]?.channel?.id ?? null;
        setDialerChannelId(defaultChannelId);
      }
    },
    [location.pathname, channelId, channelsData, call]
  );

  return children;
}
